define('enums/outbound/RecurrenceTypes',[
    'lib/knockout',
    'lib/lodash4'
], function (
    ko,
    _
) {
    'use strict';

    /*
     * Enums for recurrence types. To add a new enum, just add the id
     * (as defined by the backend) of the new recurrence type to the
     * array of types.
     *
     * Example enum:
     *
     * DAILY: {
     *     id: 'daily',
     *     equals: function (recurrenceType) {
     *         return ko.toJS(recurrenceType).id === 'daily';
     *     }
     * }
     */

    var types = ['none', 'daily', 'weekly', 'monthly'];

    var RECURRENCE_TYPES = {};

    _.forEach(types, function (type) {
        RECURRENCE_TYPES[type.toUpperCase()] = {
            id: type,
            equals: function (recurrenceType) {
                return ko.toJS(recurrenceType).id.toLowerCase() === type;
            }
        };
    });

    return RECURRENCE_TYPES;
});

